import { useEffect, useRef } from 'react';
import '../styles/mission-vision.css';

export default function MissionVision() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          const elements = sectionRef.current?.querySelectorAll('.fade-up');
          elements?.forEach((el, index) => {
            setTimeout(() => {
              (el as HTMLElement).style.animation = `fadeUp 0.8s ease forwards`;
              (el as HTMLElement).style.opacity = '1';
            }, index * 100);
          });
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="mission-vision section" id="mission" ref={sectionRef}>
      <div className="container">
        <h2 className="section-title fade-up">Sứ mạng & Tầm nhìn</h2>

        <div className="mv-grid">
          <div className="mv-card fade-up">
            <div className="mv-icon">
                <img src="/images/ctump/mission.png" alt="Sứ mạng"/>
            </div>
            <h3>Sứ mạng</h3>
            <ul className="mv-list">
              <li>Đào tạo nhân lực y tế chất lượng cao</li>
              <li>Đáp ứng nhu cầu chăm sóc sức khỏe toàn dân</li>
              <li>Phát triển vùng tây nam bộ</li>
              <li>Kết hợp giáo dục, nghiên cứu khoa học và dịch vụ</li>
              <li>Nâng cao năng lực quốc tế</li>
            </ul>
          </div>

          <div className="mv-card fade-up">
            <div className="mv-icon">
                <img src="/images/ctump/vision.png" alt="Tầm nhìn"/>
            </div>
            <h3>Tầm nhìn</h3>
            <ul className="mv-list">
              <li>Trở thành trường đại học y dược hàng đầu khu vực</li>
              <li>Cung cấp giáo dục toàn diện về y học hiện đại</li>
              <li>Phát triển công nghệ y tế tiên tiến</li>
              <li>Hợp tác quốc tế với các trường hàng đầu thế giới</li>
              <li>Đóng góp tích cực cho sức khỏe cộng đồng</li>
            </ul>
          </div>
        </div>

        {/*<div className="mv-values">
          <h3 className="values-title fade-up">Giá trị cốt lõi</h3>
          <div className="values-grid">
            <div className="value-item fade-up">
              <div className="value-number">1</div>
              <span>Chất lượng</span>
            </div>
            <div className="value-item fade-up">
              <div className="value-number">2</div>
              <span>Đạo đức</span>
            </div>
            <div className="value-item fade-up">
              <div className="value-number">3</div>
              <span>Đổi mới</span>
            </div>
            <div className="value-item fade-up">
              <div className="value-number">4</div>
              <span>Hợp tác</span>
            </div>
          </div>
        </div>*/}
      </div>
    </section>
  );
}